import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme) {
  var footerStyles = {
    display: 'flex',
    flexDirection: 'row'
  };
  return {
    content: {
      padding: "".concat(componentTheme.contentPaddingTopBottom, " ").concat(componentTheme.contentPaddingLeftRight),
      backgroundColor: componentTheme.contentBackgroundColor
    },
    breadcrumb: {
      marginBottom: "".concat(componentTheme.breadCrumbMarginBottom)
    },
    entryRow: {
      marginBottom: componentTheme.entryRowMargin
    },
    headerRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      color: componentTheme.headerRowColor,
      padding: componentTheme.headerRowPadding
    },
    leftHeader: {
      flex: '0 0 auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginRight: componentTheme.leftHeaderMargin
    },
    headerText: {
      fontSize: componentTheme.headerTextFontSize
    },
    header: {
      backgroundColor: componentTheme.headerBackgroundColor,
      color: componentTheme.headerColor,
      padding: "".concat(componentTheme.headerPaddingTopBottom, " ").concat(componentTheme.headerPaddingLeftRight),
      display: 'flex',
      justifyContent: 'space-between',
      verticalAlign: 'middle',
      alignItems: 'center'
    },
    rightHeader: {
      textAlign: 'right',
      paddingLeft: componentTheme.rightHeaderPaddingLeft
    },
    footer: _objectSpread(_objectSpread({}, footerStyles), {}, {
      textAlign: 'left',
      paddingBottom: componentTheme.footerPaddingBottom,
      paddingTop: componentTheme.footerPaddingTop
    }),
    leftFooter: footerStyles,
    rightFooter: _objectSpread(_objectSpread({}, footerStyles), {}, {
      flex: '8 0 0',
      justifyContent: 'flex-end',
      paddingLeft: componentTheme.rightFooterPaddingLeftRight,
      paddingRight: componentTheme.rightFooterPaddingLeftRight
    }),
    entryEdit: {
      borderBottom: "".concat(componentTheme.entryEditBorderWidth, " solid ").concat(componentTheme.entryEditBorderColor)
    }
  };
};
export default generateStyle;